import { getCurrentSku } from '@catalogo/core-sku';

export const tiktokInit = config => {
  document.addEventListener('page:load', ({ detail }) => {
    const { page, project } = detail;
    const enabled = config.tiktok;

    if ((project?.brand === 'acom' && [('category', 'search')].includes(page?.type)) || !enabled) {
      return null;
    }

    const tiktokTag = `
    try{
      !(function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        const ttq = (w[t] = w[t] || []);
        (ttq.methods = [
          'page',
          'track',
          'identify',
          'instances',
          'debug',
          'on',
          'off',
          'once',
          'ready',
          'alias',
          'group ',
          'enableCookie ',
          'disableCookie ',
        ]),
          (ttq.setAndDefer = function (t, e) {
            t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          });
        for (let i = 0; i < ttq.methods.length; i++) {
          ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        (ttq.instance = function (t) {
          for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
            ttq.setAndDefer(e, ttq.methods[n]);
          }
          return;
          e;
        }),
          (ttq.load = function (e, n) {
            const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
            (ttq._i = ttq._i || {}),
              (ttq._i[e] = []),
              (ttq._i[e]._u = i),
              (ttq._t = ttq._t || {}),
              (ttq._t[e] = +new Date()),
              (ttq._o = ttq._o || {}),
              (ttq._o[e] = n || {});
            const o = document.createElement('script');
            (o.type = 'text/javascript'), (o.async = !0), (o.src = ''+i+'?sdkid='+e+'&lib='+t);
            const a = document.getElementsByTagName('script')[0];
            a.parentNode.insertBefore(o, a);
          });
        ttq.load('${config.tiktok.pixelId}');
        ttq.page();
      })(window, document, 'ttq');
  
      } catch(e) {
          console.log(e);
      }
  `;

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = 1;
    script.text = tiktokTag;
    head.appendChild(script);
  });
};

export const tiktokViewContent = ({ product }) => {
  if (!product) {
    return null;
  }

  const { id, name } = product;
  const sku = getCurrentSku({ product });
  const { bestPaymentOption, currency } = sku?.offers?.result[0] || {};
  const { type: paymentType, price, minQuantity } = bestPaymentOption || {};

  window.ttq?.track('ViewContent', {
    content_id: id,
    content_type: 'product',
    content_name: name,
    quantity: 1,
    price: paymentType === 'BOLETO' ? price : minQuantity && minQuantity[0].total,
    currency,
  });
};
